// import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: ['projectInfo', 'projectSubType', 'type', 'assetsmassifs'],
  data() {
    const validateCertificateNo = (rule, value, callback) => {
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    // 总金额校验
    const validateSumPrice = (rule, value, callback) => {
      if(value === '' || value === null){
        callback(new Error('请填写以上地块发包期限内的流转总金额'));
      } else if(Number(value) < 1 || Number(value) > 9999999999) {
        callback(new Error('请输入1-9999999999以内的数字'));
      } else {
        callback();
      }
    };
    return {
      massifs: [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          woodClass: '',
          smallClass: '',
          attachment: '',
          originalContractor: '',
          certificateNo: '',
          serialNumber: '',
          forestSpecies: '',
          forestList: [
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            }
          ]
        }
      ],
      totalForm: {
        sumArea: null,
        sumPrice: null,
        sumTreeNumber: null,
        currentPrice: null
      },
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入地块面积', trigger: 'blur' }
        ],
        // serialNumber: [
        //   { required: true, message: '请输入林权证编号', trigger: 'blur' }
        // ],
        price: [
          { required: true, message: '请输入地块转让总价格', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        woodClass: [
          { required: true, message: '请输入林班信息', trigger: 'blur' }
        ],
        smallClass: [
          { required: true, message: '请输入小班信息', trigger: 'blur' }
        ],
        forestSpecies: [
          { required: true, message: '请输入林种信息', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ],
        certificateNo: [
          { required: false, validator: validateCertificateNo, trigger: 'blur' }
        ]
        // treeNumber: [
        //   { required: false, validator: this.validateTreeNumber, trigger: 'blur' }
        // ]
      },
      totalFormRules: {
        sumPrice: [
          { required: true, validator: validateSumPrice, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'tradeType',
      'transferType'
    ])
  },
  watch: {
    projectInfo: {
      handler: function() {
        console.log(this.projectInfo, '==========project0');
        const assetsInfo = this.projectInfo && this.projectInfo.assetsInfo && JSON.parse(this.projectInfo.assetsInfo);
        const arr = [];
        if(assetsInfo) {
          assetsInfo.forEach((item, index) => {
            // const obj = JSON.parse(item);
            const obj = typeof item === 'string' ? JSON.parse(item) : item;
            if(!obj.hasOwnProperty('forestList')){
              obj.forestList = this.massifs[index].forestList;
              Object.keys(obj).forEach((key) => {
                obj[key] = String(obj[key]);
              });
            } else {
              obj.forestList = typeof item === 'string' ? JSON.parse(item).forestList : item.forestList;
            }
            arr.push(obj);
          });
        }
        if (arr.length) {
          this.massifs = arr;
        }
        Object.keys(this.totalForm).forEach((key) => {
          if(this.projectInfo[key] === undefined) return;
          this.totalForm[key] = this.projectInfo && String(this.projectInfo[key]);
        });
        this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length });
      },
      immediate: true
    },
    assetsmassifs: {
      handler: function () {
        if (this.assetsmassifs.length > 0) {
          const arr = [];
          this.assetsmassifs.forEach(item => {
            arr.push({
              massifName: item.assetName,
              area: item.assetArea,
              price: null,
              toEast: item.toEast,
              toWest: item.toWest,
              toSouth: item.toSouth,
              toNorth: item.toNorth,
              assetId: item.assetId,
              woodClass: '',
              smallClass: '',
              attachment: '',
              originalContractor: '',
              certificateNo: '',
              serialNumber: '',
              forestSpecies: '',
              forestList: [
                {
                  'treeSpecies': '',
                  'treeNumber': ''
                },
                {
                  'treeSpecies': '',
                  'treeNumber': ''
                },
                {
                  'treeSpecies': '',
                  'treeNumber': ''
                }
              ]
            });
          });
          if (arr.length) {
            this.massifs = arr;
            let sumArea = 0;
            this.massifs.forEach(item => {
              sumArea += Number(item.area);
            });
            this.totalForm.sumArea = sumArea.toFixed(2);
          }
        }
      },
      immediate: true // 初始化执行
    }
  },
  methods: {
    priceVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入地块总转让价格'));
      } else if(value < 1 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入地块面积'));
      } else if(value < 0 || value > 99999.99){
        callback(new Error('请输入0-100000以内的数字'));
      } else {
        callback();
      }
    },
    // 株数校验
    validateTreeNumber(rule, value, callback) {
      if(value) {
        if(value < 0 || Number(value) > 9999999) {
          callback(new Error('请输入1-9999999以内的数字'));
        } else if(!(/^\+?[1-9]\d*$/).test(value)) {
          callback(new Error('请输入正整数'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    clear() {
      if( this.projectInfo.projectType === 2) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          woodClass: '',
          smallClass: '',
          attachment: '',
          originalContractor: '',
          certificateNo: '',
          serialNumber: '',
          forestSpecies: '',
          forestList: [
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            },
            {
              'treeSpecies': '',
              'treeNumber': ''
            }
          ]
        }
      ],
      this.totalForm = {
        sumArea: null,
        sumPrice: null,
        sumTreeNumber: null
      };
      // 清空红色必填标示
      if(this.$refs['woodsForm']) {
        this.$refs['woodsForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        serialNumber: '',
        price: null,
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        woodClass: '',
        smallClass: '',
        attachment: '',
        originalContractor: '',
        certificateNo: '',
        forestSpecies: '',
        forestList: [
          {
            'treeSpecies': '',
            'treeNumber': ''
          },
          {
            'treeSpecies': '',
            'treeNumber': ''
          },
          {
            'treeSpecies': '',
            'treeNumber': ''
          }
        ]
      });
    },
    // 删除地块
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      // let sumPrice = null;
      // this.massifs.forEach(item => {
      //   sumPrice += Number(item.price);
      // });
      // this.totalForm.sumPrice = sumPrice.toFixed(2);

      let sumTreeNumber = null;
      let treeNumber = null;
      this.massifs.forEach(item => {
        item.forestList.forEach(i => {
          treeNumber += Number(i.treeNumber);
        });
        sumTreeNumber += Number(treeNumber);
      });
      this.totalForm.sumTreeNumber = sumTreeNumber;
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    // 增加树种的时候
    changeTree() {
      let num = 0;
      if(this.massifs.length === 1) {
        this.massifs.forEach(item => {
          item.forestList.forEach(i => {
            num += Number(i.treeNumber);
          });
        });
      } else {
        this.massifs.forEach(item => {
          item.forestList.forEach(i => {
            num += Number(i.treeNumber);
          });
        });
      }
      this.totalForm.sumTreeNumber = num;
    },
    // 改变面积
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    },
    // 总金额改变
    changeSumPrice () {
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    // 协议交易 成交金额
    changeCurrentPrice () {
      this.$emit('landTotalForm', {currentPrice: this.totalForm.currentPrice, count: this.massifs.length});
    },
    // 改变价格
    changePrice (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].price)) {
        return;
      }
      this.massifs[index].price = this.massifs[index].price && Number(this.massifs[index].price).toFixed(2);
      let num = null;
      this.massifs.forEach(item => {
        num += Number(item.price);
      });
      this.totalForm.sumPrice = num.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    test() {
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          // 整体交易
          if (Number(this.transferType) === 1) {
            form.price = 0;
          }
          this.$refs[`woodsForm${index}`][0].validate((valid) => {
            if (valid) {
              num ++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验总金额
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              // 林地 总株数默认为0
              if(Number(this.projectSubType) === 2) {
                this.totalForm.sumTreeNumber = 0;
              }
              // 协议交易时 总金额为0
              if (Number(this.tradeType) === 2) {
                this.totalForm.sumPrice = 0;
              }
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifs)),
                ...this.totalForm
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    }
  }
};
